import Facebook from './facebook_DEPRECATED.jsx';
import Instagram from './instagram_DEPRECATED.jsx';
import Linkedin from './linkedin_DEPRECATED.jsx';
import LogoTwitterFill from './logo-twitter-fill_DEPRECATED.jsx';
import Twitter from './logo-twitter-fill_DEPRECATED.jsx';
import Youtube from './logo-youtube_DEPRECATED.jsx';

export default {
  Facebook,
  Instagram,
  Linkedin,
  LogoTwitterFill,
  Twitter,
  Youtube,
};
